import NewsRTFEditor from './NewsRTFEditor';
import './NewsEditionPage.css';

const NewsEditionPage = () => {
  return (
    <div className='page'>
      <div className='pageHeader'>Noticias - Edición</div>
      <div>
        <NewsRTFEditor></NewsRTFEditor>
      </div>
    </div>
  );
};

export default NewsEditionPage;
